(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hautuki-childrens-day"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hautuki-campaign')) {
  customElements.define('hautuki-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.status = this.querySelector('[data-status]');
      this.tabs = [...this.querySelectorAll('[data-step]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.querySelector('[data-step-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab,index) => {
        tab.setAttribute('role','tab');
        this.panels[index].setAttribute('role','tabpanel');
        this.panels[index].setAttribute('aria-labelledby',tab.id);
        tab.addEventListener('click',()=>this.selectStep(index),{signal});
        tab.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
          if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=this.tabs.length-1;
          if(next!==undefined){event.preventDefault();this.selectStep(next);this.tabs[next].focus();}
        },{signal});
      });
      this.selectStep(0,false);
      this.supplyOptions = [...this.querySelectorAll('[data-supply-option]')];
      this.supplyOptions.forEach((option,index) => {
        option.addEventListener('click',()=>this.selectSupply(index),{signal});
        option.addEventListener('keydown',event=>{
          let next;
          if(event.key==='ArrowRight')next=(index+1)%this.supplyOptions.length;
          if(event.key==='ArrowLeft')next=(index+this.supplyOptions.length-1)%this.supplyOptions.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=this.supplyOptions.length-1;
          if(next!==undefined){event.preventDefault();this.selectSupply(next);this.supplyOptions[next].focus();}
        },{signal});
      });
      const initialSupply = Math.max(0,this.supplyOptions.findIndex(option=>option.getAttribute('aria-checked')==='true'));
      if(this.supplyOptions.length)this.selectSupply(initialSupply,false);
      this.querySelector('[data-copy]')?.addEventListener('click',()=>this.copyCode(),{signal});
      this.querySelectorAll('[data-checkout]').forEach(link=>link.addEventListener('click',()=>this.track('checkout_click',{variant_id:link.href.match(/\/cart\/(\d+):/)?.[1]}),{signal}));
      this.querySelector('[data-hero-cta]')?.addEventListener('click',()=>this.track('hero_cta_click'),{signal});
      this.syncPhase();
      this.phaseTimer=setInterval(()=>this.syncPhase(),15000);
      document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.syncPhase();},{signal});
      this.sticky=this.querySelector('[data-sticky]');
      this.heroPassed=false;this.offerVisible=false;this.footerVisible=false;
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.target.matches('[data-hero-cta]'))this.heroPassed=entry.boundingClientRect.bottom<0;
            if(entry.target.matches('[data-offer]')){this.offerVisible=entry.isIntersecting;if(entry.isIntersecting&&!this.offerTracked){this.track('offer_view');this.offerTracked=true;}}
            if(entry.target.matches('.hu-footer'))this.footerVisible=entry.isIntersecting;
          });
          this.sticky.hidden=!(this.heroPassed&&!this.offerVisible&&!this.footerVisible);
        },{threshold:0});
        [this.querySelector('[data-hero-cta]'),this.querySelector('[data-offer]'),this.querySelector('.hu-footer')].filter(Boolean).forEach(el=>this.observer.observe(el));
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches){this.reveals=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-entering');this.reveals.unobserve(entry.target);}}),{threshold:.1});this.querySelectorAll('.hu-reveal').forEach(el=>this.reveals.observe(el));}
      }
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();this.reveals?.disconnect();clearInterval(this.phaseTimer);clearTimeout(this.copyTimer);}
    selectStep(index,track=true){this.tabs.forEach((tab,i)=>{const selected=i===index;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;this.panels[i].hidden=!selected;});if(track)this.track('routine_step_change',{step:index+1});}
    selectSupply(index,track=true){
      const option=this.supplyOptions[index];if(!option||option.disabled)return;
      this.supplyOptions.forEach((item,i)=>{const selected=i===index;item.setAttribute('aria-checked',String(selected));item.tabIndex=selected?0:-1;});
      const {months,title,regular,sale,savings,checkoutUrl,productUrl}=option.dataset;
      const card=this.querySelector('.hu-offer-card');card?.classList.add('is-switching');
      this.querySelector('[data-supply-count]').textContent=title;
      this.querySelector('[data-supply-title]').textContent=title;
      this.querySelector('[data-regular-price]').textContent=regular;
      this.querySelector('[data-event-price]').textContent=sale;
      this.querySelector('[data-compare-price]').textContent=regular;
      this.querySelector('[data-savings-value]').textContent=savings;
      this.querySelector('[data-checkout-label]').textContent=`Checkout ${title} with 12% off`;
      this.querySelectorAll('[data-checkout]').forEach(link=>link.href=checkoutUrl);
      const productLink=this.querySelector('[data-product-link]');if(productLink)productLink.href=productUrl;
      const stickyLabel=this.querySelector('[data-sticky] span');if(stickyLabel)stickyLabel.textContent=title;
      const stickyPrice=this.querySelector('[data-sticky-price]');if(stickyPrice){stickyPrice.dataset.regular=regular;stickyPrice.dataset.sale=sale;}
      this.syncPhase();requestAnimationFrame(()=>card?.classList.remove('is-switching'));
      if(track)this.track('supply_change',{months:Number(months),variant_id:option.dataset.variantId});
    }
    syncPhase(){
      const start=Date.parse(this.dataset.start),end=Date.parse(this.dataset.end),now=Date.now();
      if(!Number.isFinite(start)||!Number.isFinite(end))return;
      const phase=now<start?'upcoming':now<=end?'live':'ended';
      this.dataset.phase=phase;
      const regular=this.querySelector('[data-regular-price]');if(regular)regular.hidden=phase==='live';
      const note=this.querySelector('[data-phase-note]');if(note)note.textContent=this.messages[phase];
      const eventLabel=this.querySelector('[data-event-label]');if(eventLabel)eventLabel.textContent=phase==='live'?this.messages.withCode:this.messages.scheduled;
      const viewBag=this.querySelector('[data-view-bag]');if(viewBag)viewBag.href=phase==='live'?this.dataset.discountUrl:this.dataset.cartUrl;
      const price=this.querySelector('[data-sticky-price]');if(price)price.textContent=phase==='live'?price.dataset.sale:price.dataset.regular;
    }
    async copyCode(){
      const button=this.querySelector('[data-copy]');
      try{await navigator.clipboard.writeText(this.dataset.code);button.textContent=this.messages.copied;this.track('code_copy');clearTimeout(this.copyTimer);this.copyTimer=setTimeout(()=>{button.textContent=this.messages.copy;},2200);if(this.status)this.status.textContent=this.messages.copied;}
      catch{if(this.status)this.status.textContent=this.messages.copyFailed;const range=document.createRange();range.selectNodeContents(this.querySelector('.hu-code>span'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
    }
    async addToCart(event){
      event.preventDefault();if(this.pending)return;
      const form=event.currentTarget,button=form.querySelector('[data-buy]'),label=button.querySelector('[data-buy-label]');
      this.pending=true;button.disabled=true;button.setAttribute('aria-busy','true');label.textContent=this.messages.adding;this.status.textContent='';
      try{
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form),signal:this.controller.signal});
        const data=await response.json();
        if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.messages.error);
        this.status.textContent=this.messages.added;
        this.syncPhase();
        this.querySelector('[data-view-bag]').focus({preventScroll:true});
        this.track('add_to_cart_success',{variant_id:form.elements.id.value,quantity:1});
      }catch(error){if(error.name!=='AbortError'){this.status.textContent=error.message||this.messages.error;this.track('add_to_cart_error');}}
      finally{this.pending=false;button.disabled=false;button.removeAttribute('aria-busy');label.textContent=this.messages.add;}
    }
    track(event,detail={}){this.dispatchEvent(new CustomEvent('hautuki:analytics',{bubbles:true,detail:{event,...detail}}));}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  class PromoCountdownBar {
    constructor(element) {
      this.element = element;
      this.startTime = Date.parse(element.dataset.startTime);
      this.endTime = Date.parse(element.dataset.endTime);
      this.upcomingText = element.dataset.upcomingText || 'Coming soon';
      this.liveText = element.dataset.liveText || 'Just launched';
      this.expiredText = element.dataset.expiredText || 'Offer ended';
      this.showCentiseconds = element.dataset.showCentiseconds === 'true';
      this.days = element.querySelector('[data-pcd-days]');
      this.hours = element.querySelector('[data-pcd-hours]');
      this.minutes = element.querySelector('[data-pcd-minutes]');
      this.seconds = element.querySelector('[data-pcd-seconds]');
      this.centiseconds = element.querySelector('[data-pcd-centiseconds]');
      this.headline = element.querySelector('.pcd-bar__headline');
      this.link = element.dataset.pcdLink;
      this.modal = element.parentElement.querySelector('[data-pcd-modal]');
      this.modalContinue = this.modal ? this.modal.querySelector('[data-pcd-modal-continue]') : null;
      this.modalClose = this.modal ? this.modal.querySelector('[data-pcd-modal-close]') : null;
      this.tick = this.tick.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.showModal = this.showModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.handleModalLayerClick = this.handleModalLayerClick.bind(this);
      this.handleEscape = this.handleEscape.bind(this);
      this.goToLink = this.goToLink.bind(this);
      if (this.link) {
        this.element.addEventListener('click', this.handleClick);
        this.element.addEventListener('keydown', this.handleKeydown);
        if (this.modalContinue) {
          this.modalContinue.addEventListener('click', this.closeModal);
        }
        if (this.modalClose) {
          this.modalClose.addEventListener('click', this.closeModal);
        }
        if (this.modal) {
          this.modal.addEventListener('click', this.handleModalLayerClick);
        }
      }
      if (this.modal && window.sessionStorage.getItem('pcdDiscountModalPending') === 'true') {
        window.sessionStorage.removeItem('pcdDiscountModalPending');
        window.setTimeout(this.showModal, 350);
      }
      this.tick();
    }

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    handleClick(event) {
      if (event.target.closest('a')) {
        return;
      }
      this.goToLink();
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      event.preventDefault();
      this.goToLink();
    }

    showModal() {
      if (!this.modal) {
        return;
      }
      this.modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.handleEscape);
    }

    closeModal() {
      if (this.modal) {
        this.modal.hidden = true;
      }
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.handleEscape);
    }

    handleModalLayerClick(event) {
      if (event.target === this.modal || event.target === this.modalClose) {
        this.closeModal();
      }
    }

    handleEscape(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }

    goToLink() {
      window.sessionStorage.setItem('pcdDiscountModalPending', 'true');
      window.location.href = this.link;
    }

    tick() {
      const now = Date.now();
      const hasStartTime = Number.isFinite(this.startTime);
      const hasEndTime = Number.isFinite(this.endTime);
      let targetTime = this.endTime;
      let headlineText = this.liveText;

      if (hasStartTime && now < this.startTime) {
        headlineText = this.upcomingText;
      }

      const distance = targetTime - now;

      if (!hasEndTime || now >= this.endTime || distance <= 0) {
        this.days.textContent = '00';
        this.hours.textContent = '00';
        this.minutes.textContent = '00';
        this.seconds.textContent = '00';
        if (this.centiseconds) {
          this.centiseconds.textContent = '00';
        }
        if (this.headline) {
          this.headline.textContent = this.expiredText;
        }
        return;
      }

      if (this.headline) {
        this.headline.textContent = headlineText;
      }

      const totalSeconds = Math.floor(distance / 1000);
      this.days.textContent = this.pad(Math.floor(totalSeconds / 86400));
      this.hours.textContent = this.pad(Math.floor((totalSeconds % 86400) / 3600));
      this.minutes.textContent = this.pad(Math.floor((totalSeconds % 3600) / 60));
      this.seconds.textContent = this.pad(totalSeconds % 60);

      if (this.centiseconds) {
        this.centiseconds.textContent = this.pad(Math.floor((distance % 1000) / 10));
      }

      if (this.showCentiseconds) {
        window.requestAnimationFrame(this.tick);
      } else {
        window.setTimeout(this.tick, 250);
      }
    }
  }

  document.querySelectorAll('[data-pcd-bar]').forEach((element) => {
    if (!element.dataset.pcdInitialized) {
      element.dataset.pcdInitialized = 'true';
      new PromoCountdownBar(element);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
